<template lang="pug">
.modal-validar-finalizar
    .linha
        b.coluna {{ text }}
    .linha
        .coluna
            .modal-footer(:style='[ { display: "flex" },  { justifyContent: "space-between" }, { marginTop: "30px" } ]')
                button-component(
                    label='Cancelar',
                    icon='mdi-close',
                    background-color='var(--primary-gray)',
                    color='var(--primary-light-smoke)',
                    @click.native='$emit("validarFinalizar", false)'
                )
                button-component(label='Concluir', @click.native='$emit("validarFinalizar", true)')
</template>

<script>
export default {

    name: 'ModalValidarFinalizar',

    props: {
        text: {
            type: String,
            default: null
        }
    },

    data() {
        return {
        }
    }
}
</script>

<style lang="scss"></style>
